import CategoryCard from "./CategoryCard";
import { DroneCategoriesCard } from "./Data";
const DroneCategories = () => {
  return (
    <div className="min-h-fit bg-slate-50  font-sans text-white antialiased">
      <div className="mx-auto max-w-7xl py-4 px-4 sm:py-6 sm:px-6 lg:px-8">
        <h2 className="text-center text-3xl sm:text-4xl lg:text-4xl font-extrabold text-slate-600 tracking-tight my-2 md:my-4">
          Drone{" "}
          <span className="relative inline-block">
            <span className="absolute inset-0 bg-sky-200/50 -skew-y-2 transform rounded-lg"></span>
            <span className="relative text-sky-600">Categories </span>
          </span>{" "}
        </h2>
        <div className="mt-10 grid grid-cols-1 gap-y-12 gap-x-8 sm:grid-cols-2 lg:grid-cols-4">
          {DroneCategoriesCard.map((card) => (
            <CategoryCard
              key={card.title}
              image={card.image}
              title={card.title}
              description={card.description}
              url={card.url}
              icon={card.icon}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DroneCategories;
